module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_retail-66aed036.png";